---
fr:
  data_export:
    budget_revenue: Revenu budgétaire
    budget_volume: Volume budgétaire
    downtime_comment: Commentaires sur interruptions
    downtime_cost: Coût de l'interruption
    downtime_reason: Raisons de l'interruption
    downtime_volume: Pertes durant interruption
    from_date: De (date)
    heading: Exporter les valeurs horaires dans une feuille de calcul
    individual_power_plants: Sélectionner des centrales électriques individuelles
    missing_exchange_rate_error: Les données de taux de change sont manquantes pour la période et la devise sélectionnées. Veuillez contacter le support.
    pending_email: Le tableur sera envoyé par e-mail une fois prêt.
    power_plants: Centrales électriques
    price_areas: Sélectionner toutes les centrales dans la zone tarifaire
    prices: Prix
    rate_limited: Trop de requêtes
    ready_notification:
      body: Cliquez sur Voir pour télécharger le tableur.
      title: Votre export de données est prêt
    report:
      budget_revenue:
        report_sheet_header: Revenu
        report_sheet_name: Revenu budgétaire
        summary_sheet_header: Revenu budgétaire %{currency}
      budget_volume:
        report_sheet_header: MWh
        report_sheet_name: Volume budgétaire
        summary_sheet_header: Volume budgétaire MWh
      downtime_comment:
        report_sheet_header: Commentaires
        report_sheet_name: Commentaires sur l'interruption
      downtime_cost:
        report_sheet_header: Coût
        report_sheet_name: Coût de l'interruption
        summary_sheet_header: Coût total interruption %{currency}
      downtime_reason:
        report_sheet_header: Raison
        report_sheet_name: Raison de l'interruption
      downtime_volume:
        report_sheet_header: MWh
        report_sheet_name: Pertes interruption
        summary_sheet_header: Pertes totales interruption MWh
      monthly_sheet_left_header: Centrale électrique
      monthly_sheet_sum_header: TOTAL
      monthly_sheet_title: Résumé mensuel
      monthly_sheet_top_header: Période
      prices:
        report_sheet_header: Prix
        report_sheet_name: Prix
        summary_sheet_header: Prix (%{currency})
      report_sheet_left_headers:
      - Fuseau horaire
      - Heure
      revenue:
        report_sheet_header: Revenu
        report_sheet_name: Revenu
        summary_sheet_header: Revenu brut %{currency}
      summary_sheet_left_header: Export de données
      summary_sheet_title: Résumé
      summary_sheet_top_header: Période
      volume:
        report_sheet_header: MWh
        report_sheet_name: Production
        summary_sheet_header: Production MWh
    report_types: Types de rapport
    revenue: Revenu
    select_power_plants: Sélection des centrales électriques
    to_date: À (date)
    volume: Production
  errors:
    messages:
      export_too_large: L'export est trop volumineux. Merci d'essayer avec une période plus courte.
      no_power_plants_selected: Aucune centrale sélectionnée
